import {UserData} from 'models/user-interface';

export interface InitialAuthState {
  isLoading: boolean;
  user: UserData | null;
  accessToken: string | null;
  refreshToken: string | null;
  isLoggedIn: boolean;
  isPasswordChanged: boolean;
}

const initialAuthState: InitialAuthState = {
  isLoading: false,
  user: null,
  accessToken: null,
  refreshToken: null,
  isLoggedIn: false,
  isPasswordChanged: false,
};

export default initialAuthState;
